import React, { FunctionComponent } from 'react';
import {
  AsyncState,
  CoursesFilterData,
  InstitutionAdminSettingsState,
  ValidActionType,
} from 'src/ReduxStorage/InstitutionAdminSettings/types';
import {
  PortalResourceGetPaginatedEnrolments,
  PortalResourceGetPaginatedPendingInvitations,
} from 'src/resource/PortalResource/types';
import { ActiveLearnersTable } from './ActiveLearnersTable/component';
import { PendingLearnersTable } from './PendingLearnersTable/component';
import {
  EmptyContentWrapper,
  Header,
  PendingTeamAlertMessage,
  AddTeamMember,
  GlobalStylingForModal,
  ContentWrapper,
} from './../../styles';
import baloonImage from '../../images/Undraw_Floating balloons.svg';

export interface ViewLearnersProps {
  paginatedInstitutionEnrolments: InstitutionAdminSettingsState['paginatedInstitutionEnrolments'];
  paginatedPendingInvitations: InstitutionAdminSettingsState['paginatedPendingInvitations'];
  currentInstitutionPath: string;
  allCoursesFilterData: CoursesFilterData;

  changeNavState: (nav: ValidActionType) => void;
  getPaginatedEnrolments: (
    params: PortalResourceGetPaginatedEnrolments['args']
  ) => Promise<unknown>;
  getPaginatedPendingInvitations: (
    params: PortalResourceGetPaginatedPendingInvitations['args']
  ) => Promise<unknown>;
}

export const ViewLearners: FunctionComponent<ViewLearnersProps> = ({
  paginatedInstitutionEnrolments,
  paginatedPendingInvitations,
  currentInstitutionPath,
  changeNavState,
  getPaginatedEnrolments,
  getPaginatedPendingInvitations,
  allCoursesFilterData,
}) => {
  const {
    enrolments,
    total,
    totalPages,
    asyncState,
  } = paginatedInstitutionEnrolments;
  const {
    asyncState: asyncStatePendingInvitations,
    ...restPaginatedPendingInvitations
  } = paginatedPendingInvitations;

  const isActivePendingMembersEmpty = false;
  const allCourses = Object.keys(allCoursesFilterData).map(
    (coursePath) => allCoursesFilterData[coursePath]
  );

  if (isActivePendingMembersEmpty) {
    return (
      <EmptyContentWrapper>
        <img alt="Empty data icon" src={baloonImage} />
        <h1>No learners yet</h1>
        <p>Get started by adding some learners to your institution.</p>
        <AddTeamMember
          type="button"
          onClick={() => changeNavState(ValidActionType.ADD_MEMBER)}
        >
          Add learners
        </AddTeamMember>
      </EmptyContentWrapper>
    );
  }
  return (
    <ContentWrapper>
      {GlobalStylingForModal}
      <ActiveLearnersTable
        currentInstitutionPath={currentInstitutionPath}
        enrolments={enrolments}
        total={total}
        totalPages={totalPages}
        getPaginatedEnrolments={getPaginatedEnrolments}
        isLoadingData={asyncState === AsyncState.LOADING}
        allCourses={allCourses}
      />
      <hr />
      <Header>Pending learners</Header>
      <PendingTeamAlertMessage
        kind="info"
        message={
          <div>
            Learners who appear as pending have been invited to the institution,
            but:
            <ul>
              <li>Don’t have an account on OpenLearning; or</li>
              <li>Have an unverified account on OpenLearning.</li>
            </ul>
          </div>
        }
      />
      <PendingLearnersTable
        currentInstitutionPath={currentInstitutionPath}
        paginatedPendingInvitations={restPaginatedPendingInvitations}
        isLoading={asyncStatePendingInvitations === AsyncState.LOADING}
        getPaginatedPendingInvitations={getPaginatedPendingInvitations}
        allCourses={allCourses}
      />
    </ContentWrapper>
  );
};
